import { useState } from 'react'
import styled from 'styled-components'

export const Lightbox = ({ fullscreen, experience }: { fullscreen?: boolean; experience: Survey }) => {
  const [open, setOpen] = useState(false)

  return (
    <StyledLightbox open={open}>
      {fullscreen && <Backdrop open={open} />}
      <Launcher onClick={() => setOpen(!open)}>
        <Plus open={open}>+</Plus>
      </Launcher>
      <Popup open={open}>
        <IFrame src={`https://dev-engage.trystoryforms.com/form/${experience.customId}`} />
      </Popup>
    </StyledLightbox>
  )
}

const StyledLightbox = styled.div<{ open: boolean }>`
  position: fixed;
  bottom: 100px;
  right: 30px;
  z-index: 999999;
  pointer-events: ${({ open }) => (open ? 'all' : 'none')};
`

const Backdrop = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff3;
  transition: 150ms backdrop-filter ease;
  width: ${({ open }) => (open ? '100vw' : '0')};
  height: ${({ open }) => (open ? '100vh' : '0')};
  backdrop-filter: ${({ open }) => (open ? 'blur(3px)' : 'blur(0px)')};
`

const Launcher = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  font-family: Courier, monospace;
  font-weight: 300;
  color: #ffffff;
  position: fixed;
  bottom: 20px;
  right: 40px;
  height: 56px;
  width: 56px;
  border-radius: 50%;
  background-color: #0288d1;
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%),
    0px 1px 18px 0px rgb(0 0 0 / 12%);
  cursor: pointer;
  user-select: none;
  transition: 300ms background-color ease;
  pointer-events: all;

  &:hover {
    background-color: #245696;
  }
`

const Plus = styled.p<{ open: boolean }>`
  transition: 300ms transform ease;
  transform: ${({ open }) => (open ? 'rotate(135deg)' : 'rotate(0deg)')};
  font-size: 30px;
  margin: 0;
  user-select: none;
`

const Popup = styled.div<{ open: boolean }>`
  position: relative;
  right: 0;
  bottom: 0;
  width: 900px;
  height: 600px;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 5px -1px, rgb(0 0 0 / 14%) 0px 6px 10px 0px,
    rgb(0 0 0 / 12%) 0px 1px 18px 0px;
  background-color: white;
  border-radius: 4px;
  opacity: ${({ open }) => (open ? 1 : 0)};
  transform-origin: bottom right;
  transform: ${({ open }) => (open ? 'scale(1)' : 'scale(0.7)')};
  transition: 300ms all ease;
  user-select: none;
  pointer-events: ${({ open }) => (open ? 'all' : 'none')};
`

const IFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 4px;
`
